import React, { useEffect, useState } from 'react';
import { fetchSevagramLeaderboard } from '../../lib/api';

const GlobalLeaderboard = ({ activeHandle }) => {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchSevagramLeaderboard(10)
      .then(setRows)
      .catch(() => setRows([]))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div data-testid="leaderboard-loading" className="space-y-2">
        {[0, 1, 2].map((i) => (
          <div key={i} className="h-12 bg-[#C1D7E2]/40 animate-pulse" />
        ))}
      </div>
    );
  }

  return (
    <ol data-testid="dashboard-leaderboard" className="divide-y divide-[#C1D7E2]">
      {rows.map((c, i) => {
        const isMe = c.handle === activeHandle;
        return (
          <li
            key={c.handle}
            data-testid={`leaderboard-row-${i}`}
            className={`flex items-center gap-4 py-4 ${
              isMe ? 'bg-[#C1D7E2]/30 -mx-3 px-3' : ''
            }`}
          >
            <span className="font-mono text-xs tracking-[0.2em] text-[#90B0BF] w-6">
              {String(i + 1).padStart(2, '0')}
            </span>
            {c.avatar_url ? (
              <img
                src={c.avatar_url}
                alt=""
                className="w-10 h-10 rounded-full object-cover border border-[#C1D7E2]"
              />
            ) : (
              <div className="w-10 h-10 rounded-full bg-[#C1D7E2]" />
            )}
            <div className="flex-1 min-w-0">
              <p className="font-serif text-base text-[#7C9CB1] truncate">
                {c.display_name}
                {isMe && (
                  <span className="ml-2 font-mono text-[10px] tracking-[0.25em] uppercase text-[#90B0BF]">
                    · you
                  </span>
                )}
              </p>
              <p className="font-mono text-[10px] text-[#90B0BF] truncate">
                @{c.handle}
              </p>
            </div>
            <p className="font-mono text-sm text-[#7C9CB1] whitespace-nowrap">
              {Number(c.seva_earned || 0).toFixed(0)} SEVA
            </p>
          </li>
        );
      })}
      {rows.length === 0 && (
        <li className="font-serif italic text-[#90B0BF] py-6">
          The leaderboard is quiet — be the first.
        </li>
      )}
    </ol>
  );
};

export default GlobalLeaderboard;
